import { useAtomValue } from "jotai";
import { useCopilotDrawerState as useOriginalCopilotDrawerState } from "@zapier/ai-toolkit/client";
import { isCopilotEnabledAtom } from "@zapier/canvas-state";

/**
 * Wrapper hook that combines copilot drawer state with enabled state.
 *
 * Returns [isOpen, setIsOpen] where:
 * - isOpen: true only if copilot is enabled AND drawer is open
 * - setIsOpen: function to control drawer state (normal state management)
 *
 * This eliminates the need for components to manually check isCopilotEnabled
 * when working with copilot drawer state.
 *
 * Use this instead of the original useCopilotDrawerState from ai-toolkit/client
 */
export function useCopilotDrawerState(): [
  boolean,
  (value: boolean | ((prev: boolean) => boolean)) => void,
] {
  const [isOpen, setIsOpen] = useOriginalCopilotDrawerState();
  const isCopilotEnabled = useAtomValue(isCopilotEnabledAtom);

  // Return the enabled-aware state and setter
  return [isCopilotEnabled && isOpen, setIsOpen];
}
